import React from "react"


export const useValidateNationalityUsingMot=(isImportShipment,mot)=>{
   return React.useMemo(()=>{
         
    const response={}
    
    if(!isImportShipment){
        response.isTransNationalityVisible=["2", "5","7"].includes(mot)
        response.validationMsg=<ul><li>if MOT is 2,5 or 7 then Nationality will be disabled.</li></ul>
      
    }
  
    return response
},[isImportShipment,mot])
}